export enum DocumentsApiActionTypes {
  LoadTagsSuccess = '[Documents API] Load Tags Success',
  LoadTagsFailure = '[Documents API] Load Tags Failure',

  LoadPolicyDocumentsSuccess = '[Documents API] Load Policy Documents Success',
  LoadPolicyDocumentsFailure = '[Documents API] Load Policy Documents Failure',

  FolderDocumentsLoadedSuccess = '[Documents API] Folder Documents Loaded Success',
  FolderDocumentsLoadedFailure = '[Documents API] Folder Documents Loaded Failure',

  DocumentUploadedSuccess = '[Documents API] Documents Uploaded Success',
  DocumentUploadedFailure = '[Documents API] Documents Uploaded Failure',

  DocumentUploadCompleted = '[Documents API] Documents Upload Completed',

  DocumentUpdatedSuccess = '[Documents API] Document Updated Success',
  DocumentUpdatedFailure = '[Documents API] Document Updated Failure',

  DownloadSuccess = '[Documents API] Download Success',
  DownloadFailure = '[Documents API] Download Failure',

  DeletedSuccess = '[Documents API] Deleted Success',
  DeletedFailure = '[Documents API] Deleted Failure',
}
